import { useState } from 'react';
import FullscreenOverlay from '../../../ui/FullscreenOverlay';
import { useDetailPanelSafe } from '../../../ui/DetailPanel';
import { RatingsDisclaimer } from './RatingsDisclaimer';
import { disclaimerTrigger } from './nearbySchoolsModule.styles';

const DisclaimerPanel = () => <RatingsDisclaimer />;

export const DisclaimerTrigger = () => {
  const detailPanel = useDetailPanelSafe();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (detailPanel && !detailPanel.isMobile) {
    return (
      <button
        type="button"
        className={disclaimerTrigger}
        onClick={() => detailPanel.openPanel('school-ratings-disclaimer', DisclaimerPanel, { stacked: true })}
      >
        Learn more.
      </button>
    );
  }

  return (
    <FullscreenOverlay.Root open={mobileOpen} onOpenChange={setMobileOpen}>
      <FullscreenOverlay.Trigger asChild>
        <button type="button" className={disclaimerTrigger}>
          Learn more.
        </button>
      </FullscreenOverlay.Trigger>
      <FullscreenOverlay.Portal>
        <FullscreenOverlay.Backdrop>
          <FullscreenOverlay.Content>
            <FullscreenOverlay.Header title="About the ratings" />
            <FullscreenOverlay.Body>
              <RatingsDisclaimer />
            </FullscreenOverlay.Body>
          </FullscreenOverlay.Content>
        </FullscreenOverlay.Backdrop>
      </FullscreenOverlay.Portal>
    </FullscreenOverlay.Root>
  );
};
